import "../../../../stylesheets/payment_methods/mercadopago";



// CheckoutAPI
export default async (bricksBuilder, response) => {
  const settings = {
    initialization: {
      amount: response['amount'],
      preferenceId: response['preference_id'],
      payer: {
        firstName: response['donator_name'],
        lastName: response['donator_last_name'],
        email: response['donator_email'],
      },
      customization: {
        visual: {
          style: {
            theme: "default",
          },
        },
        paymentMethods: {
          creditCard: "all",
          debitCard: "all",
          ticket: "all",
          bankTransfer: "all",
          onboarding_credits: "all",
          wallet_purchase: "all",
          maxInstallments: 1
        },
      },
    },
    callbacks: {
      onReady: () => {
        $("#loader").hide();
        $("#mercadopago-payment-modal").modal("show");
      },
      onSubmit: (formData) => {
        return new Promise((resolve, reject) => {
          fetch(response['url'], {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
          })
            .then((response) => response.json())
            .then((response) => {
              window.location.href = response['url'];
              resolve();
            })
            .catch((error) => {
              alert("Ha ocurrido un error al intentar crear el pago, por favor intenta nuevamente.");
              reject();
            });
        });
      },
      onError: (error) => {
        alert("Ha ocurrido un error al intentar crear el pago, por favor intenta nuevamente.");
        console.error(error);
      },
    },
  };
  window.cardPaymentBrickController = await bricksBuilder.create(
    'cardPayment',
    'cardPaymentBrick_container',
    settings,
  );
};